export default __webpack_public_path__ + "static/media/document.0f62a37b.svg";